import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-collect',
  name: 'Access Collect',
  category: 'access-integrations',
  description: 'Access Collect credit control integration',
  icon: 'DollarSign',
  color: 'orange',
  version: '1.0.0',
  
  defaults: {
    name: 'Access Collect',
    color: '#f97316' // Orange color
  },
  
  comingSoon: false,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  tags: ['access', 'collect', 'credit-control', 'integration'],

  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'access_collect_credit_control',
    description: 'Interact with Access Collect credit control system to retrieve or update customer data, transactions, disputes, and collection strategies',
    allowManualDescription: false,
    parameters: {
      action: {
        toolParamName: 'action',
        description: 'The operation to perform: getAllCustomers, getAllTransactions, getAllDisputes, getAllCollectionStrategies, or updateDispute',
        required: true,
        type: 'string',
      },
      companyId: {
        toolParamName: 'companyId',
        description: 'The company ID for multi-tenancy (X-Company-Id header)',
        required: true,
        type: 'number',
      },
      queryParams: {
        toolParamName: 'queryParams',
        description: 'Optional query parameters as a URL-encoded string (e.g., Page=1&PageSize=50&Search=customer)',
        required: false,
        type: 'string',
      },
      disputeId: {
        toolParamName: 'disputeId',
        description: 'The dispute ID to update (required only for updateDispute action)',
        required: false,
        type: 'string',
      },
      body: {
        toolParamName: 'body',
        description: 'JSON body for the update request (required only for updateDispute action). Must be a valid JSON string.',
        required: false,
        type: 'string',
      },
      instanceId: {
        toolParamName: 'instanceId',
        description: 'Optional instance ID for the request (X-Instance-Id header)',
        required: false,
        type: 'string',
      },
      environment: {
        toolParamName: 'environment',
        description: 'The environment to use: preprod, staging, or production',
        required: false,
        type: 'string',
      },
    },
    outputMapping: {
      success: 'Whether the operation succeeded',
      statusCode: 'HTTP status code of the response',
      action: 'The action that was performed',
      companyId: 'The company ID used',
      data: 'The response data (customers, transactions, disputes, strategies, or updated dispute)',
      filters: 'The query filters that were applied',
    },
  },
};

export default definition;
